<template>
  <div>
    <div v-if="!submitted">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg-3">
                    <p style="color: #5e99ff; font-size: 24px; font-weight: 300">
                      COLLECTION SCHEDULE
                    </p>
                  </div>
                  <div class="col-lg-6"></div>
                </div>
                <div class="row">
                  <div class="col-lg-3">
                    <p style="
                        color: #A5A5A5;
                        opacity: 0.7;
                        margin-top: -10px;
                        font-size: 15px;
                        font-weight: 300;
                      ">
                      Select collection date: {{ selectedDate }}
                    </p>
                  </div>
                  <div class="col-lg-6"></div>
                </div>
                <div class="row">
                  <div class="col-lg" style="width: 1200px">
                    <full-calendar ref="calendar" @changeMonth="handleMonthChange" :events="demoEvents"
                      @dayClick="dayClick" style="color: #000000 !important" :firstDay="1">
                    </full-calendar>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 text-right">
              <base-button wide type="cancel" @click.native="exitTab" class="btn-dispute">
                Back
              </base-button>

              &nbsp;

              <base-button type="primary" wide @click.native="nextTab" class="btn-next"
                :disabled="selectedDate === null || selectedDate === ''">
                Next
              </base-button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div v-if="!selectedDate" class="col-lg-3 text-right">
              <p style="color: #ff0000; font-size: 12px">
                Please select a date.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <!-- <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 text-right">
              
              <base-button
                class="btn-link"
                style="
                  color: #052d72;
                  cursor: pointer;
                  text-decoration: underline;
                "
                @click="saveDraft()"
                
              >
                Save Draft
            </base-button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div v-if="submitted">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg-3">
                    <p style="color: #5e99ff; font-size: 24px; font-weight: 300">
                      COLLECTION SCHEDULE
                    </p>
                  </div>
                  <div class="col-lg-6"></div>
                </div>
                <div class="row">
                  <div class="col-lg-3">
                    <p style="
                        color: #A5A5A5;
                        opacity: 0.7;
                        margin-top: -10px;
                        font-size: 15px;
                        font-weight: 300;
                      ">
                      Select collection date: {{ this.selectedDate1 }}
                    </p>
                  </div>
                  <div class="col-lg-6"></div>
                </div>
                <div class="row">
                  <div class="col-lg" style="width: 1200px">
                    <full-calendar ref="calendar" id="calendar" :events="demoEvents" style="color: #000000 !important">
                    </full-calendar>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 text-right">
              <base-button wide type="cancel" @click.native="exitTab" class="btn-dispute">
                Back
              </base-button>

              &nbsp;

              <base-button type="primary" wide @click="nextTab" class="btn-next">
                Next
              </base-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <!-- <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 text-right">
              <p
                style="
                  color: #052d72;
                  cursor: pointer;
                  text-decoration: underline;
                "
                @click="saveDraft()"
              >
                Save Draft
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from "vue-fullcalendar";

import moment from "moment";

export default {
  components: {
    FullCalendar,
  },
  data() {
    return {
      jobno: "",
      selectedDate: "",
      selectedDate1: null,
      submitted: false,
      demoEvents: [],
      step: 0,
    };
  },
  mounted() { },
  methods: {
    // saveDraft(){
    //   sessionStorage.setItem("collectiondate", this.selectedDate);
    // },
    viewChange(date) {
      this.$refs.calendar.currentDate = date;
    },
    handleMonthChange(start, end, current) { },
    getData(view, element) {
      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          console.log("masuk sini");
          let parameter = {
            step: 1,
            direction: "depan",
            data: [],
          };
          this.$emit("my-event", parameter);

          this.selectedDate1 = moment(response.arrival_eta).format(
            "YYYY-MM-DD"
          );

          this.viewChange(this.selectedDate1);

          let obj = {
            title: "Collection Date",
            start: this.selectedDate1,
            end: this.selectedDate1,
            time: "09:00",
            cssClass: ["chosen"],
          };

          if (!Array.isArray(this.demoEvents)) {
            this.demoEvents = [];
          }

          this.demoEvents = [obj];

          // for (var i = 0; i < response.waste_detail.length; i++) {
          //   let obj = {
          //     id: "1",
          //     description: response.waste_detail[i].waste_type_name,
          //     rate: response.waste_detail[i].rate,
          //     estamt: response.waste_detail[i].estimate_quantity,
          //     amount: response.waste_detail[i].estimate_quantity,
          //   };
          //   amountt += response.waste_detail[i].estimate_quantity;
          //   this.tableDatas.push(obj);
          // }
        }
      });
    },

    //cannot select past date than today
    dayClick(day) {
      let clickedDate = moment(day).startOf("day");

      let today = moment().startOf("day");

      if (clickedDate.isSameOrAfter(today)) {
        this.selectedDate = clickedDate.format("YYYY-MM-DD").toString();
        sessionStorage.setItem("collectiondate", this.selectedDate);
        this.$root.$emit("lalalala", this.selectedDate);

        let obj = {
          title: "Collection Date",
          start: this.selectedDate,
          end: this.selectedDate,
          time: "09:00",
          cssClass: ["chosen"],
        };

        if (!Array.isArray(this.demoEvents)) {
          this.demoEvents = [];
        }

        this.demoEvents = [obj];
      } else {
      }

      this.selectedDate = clickedDate.format("YYYY-MM-DD").toString();
      sessionStorage.setItem("collectiondate", this.selectedDate);
      console.log('dtaee', this.selectedDate)
    },

    nextTab() {
      let parameter = {
        step: "1",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    async exitTab() {
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },

    getDownload() { },

    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
    getStatus() {
      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.step = parseInt(response.step);

          if (this.step == 0 || this.step == 1) {
            let parameter = {
              step: "0",
              direction: "depan",
              data: [],
            };
            this.$emit("my-event", parameter);
            // this.nextTab()
          }

          if (this.step == 2) {
            let parameter = {
              step: "1",
              direction: "depan",
              data: [],
            };
            this.$emit("my-event", parameter);
            // this.nextTab()
          }
          if (this.$route.params.action == "edit") {
            let parameter = {
              step: "1",
              direction: "depan",
              data: [],
            };
            this.$emit("my-event", parameter);
          }
        }
      });
    },
  },
  created() {
    console.log("landed here");
    this.jobno = this.$route.params.jobnum;
    if (this.$route.params.action == "add") {
      this.submitted = false;
    }
    if (this.$route.params.action == "view") {
      this.submitted = true;
      // this.getData();
    }

    this.getStatus();
  },
  computed: {},
  watch: {
    selectedDate() { },
  },
};
</script>
<style>
.comp-full-calendar {
  min-width: none !important;
  max-width: none !important;
  width: 100%;
  /* background: red; */
}

.header-center {
  text-align: right !important;
}

.header-right {
  display: none;
}

.day-cell .day-number {
  color: #A5A5A5;
}

.day-cell .not-cur-month {
  color: #A5A5A5 !important;
  opacity: 0.5;
}
</style>
